import {
  Building2,
  MapPinned,
  PackageCheck,
  Package,
  Truck,
} from "lucide-react";
import type { ProfessionalFulfillmentStage } from "@/services/notaryRequestsService";

const STAGE_LABELS: Record<ProfessionalFulfillmentStage, string> = {
  at_platform: "En Gestionalo",
  awaiting_consumer_delivery_details: "Esperando datos de envío",
  awaiting_shipment_to_consumer: "Listo para enviar",
  in_transit_to_consumer: "En camino al solicitante",
  delivered_to_consumer: "Entregado al solicitante",
};

const STAGE_ICONS: Record<
  ProfessionalFulfillmentStage,
  typeof Building2
> = {
  at_platform: Building2,
  awaiting_consumer_delivery_details: MapPinned,
  awaiting_shipment_to_consumer: Package,
  in_transit_to_consumer: Truck,
  delivered_to_consumer: PackageCheck,
};

export interface FulfillmentStageChipProps {
  stage: ProfessionalFulfillmentStage;
  size?: "sm" | "md";
}

export function FulfillmentStageChip({
  stage,
  size = "md",
}: FulfillmentStageChipProps): JSX.Element {
  const Icon = STAGE_ICONS[stage];
  const label = STAGE_LABELS[stage];
  const sizeClass =
    size === "sm"
      ? "px-2 py-0.5 text-[11px]"
      : "px-2.5 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-sky-400/30 bg-sky-500/15 font-medium text-sky-300 ${sizeClass}`}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {label}
    </span>
  );
}
